const MODULE_NAME = "INDICATORS_";
const RECEIVE_MESSAGE = MODULE_NAME + "RECEIVE_MESSAGE";
const RECEIVE_EVENT = MODULE_NAME + "RECEIVE_EVENT";

export {
  RECEIVE_MESSAGE,
  RECEIVE_EVENT
};
